import { LtlShipment } from "~/features/ltl-shipment/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const LtlShipmentPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlShipmentPage");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <LtlShipment /> : <Construction />;
};
